import format from "./Util_methods/format";
import * as am4core from "@amcharts/amcharts4/core";
export const amChartsKey = "CH387747964";
export const baseUrl:string = "api/";
export const ppLogoStyle:any = { width: "4.5em" }; //inline to override semantic list:img css
/*
let startDate:any = new Date();
startDate.setDate(startDate.getDate() - 6);
*/
var startDate = new Date(new Date().getFullYear(), 0, 1);
let end:any = new Date();
export const defaultDate:any = { start: startDate, end: end };

export const defaultDateStrings:any={
    start: format.date(startDate), end: format.date(end)
}

let maxDate:any = new Date();
maxDate.setHours(24, 0, 0, 0);
export const max:any = maxDate;
export const min:any = new Date(2012, 1, 1);

//colors for charts

export const appName: string = "Global Analytics";
export const countColor = "#a1d1ff";
export const durationColor = "#c882fa";
export const machineTimeColors = {
    running: am4core.color("green"),
    failure: am4core.color("red"),
    failureTimeout: am4core.color("pink"),
    idleAdferRunning: am4core.color("yellow"),
    idleAfterFailure: am4core.color("orange"),   
    shift: am4core.color("blue")
}; 

const defaultGroupingOption = "sum";

